import config from './config'

const url = config.URL
export const ACCOUNT_MANAGER = url + '/account-manager'
export const COMMUNITY = url + '/community'
export const CATEGORY = url + '/category-creation'
export const TIMESLOT = url + '/timeslot'
export const USER_PROFILE = url + '/user-profile'
export const OBJECT_ADMIN = url + '/object-administration'
export const TRANSACTIONS = url + '/transaction-handler'
export const RENT = url + '/rent-manager'
export const NOTIFICATIONS = url + '/notifications'
export const PAYMENTS = url + '/payments'



// WEBPACK FOOTER //
// ./src/endpoints.js